import { c as _c } from "react/compiler-runtime";
import { CustomerSku } from "@sticker-giant/sg-frontend-common";
import { useCustomerSkus } from "@/queries/useCustomer";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionLabel from "./OptionLabel";
import { useProductBuilderContext } from "./ProductBuilderContext";
import RollQuantity from "./RollQuantity";
import RollQuantityPreference from "./RollQuantityPreference";
import { useProductMicrocopy } from "./useProductMicrocopy";
import ValidationError from "./ValidationError";
export default function RollQuantityField() {
  const $ = _c(15);
  const {
    product
  } = useProductBuilderContext();
  const microcopyFields = useProductMicrocopy();
  const rollDriver = usePdpStore(_temp);
  const {
    customerSkus
  } = useCustomerSkus();
  const controlIdBase = `roll-quantity-${product.sku}`;
  const labelId = `${controlIdBase}-label`;
  const t0 = microcopyFields?.rollQuantityLabel ?? "Roll Quantity";
  const t1 = microcopyFields?.rollQuantityHelper;
  const t2 = `${controlIdBase}-helper-dialog`;
  let t3;
  if ($[0] !== labelId || $[1] !== t0 || $[2] !== t1 || $[3] !== t2) {
    t3 = <OptionLabel id={labelId} label={t0} helper={t1} helpDialogId={t2} />;
    $[0] = labelId;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== labelId) {
    t4 = <RollQuantityPreference labelId={labelId} />;
    $[5] = labelId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== customerSkus || $[8] !== labelId || $[9] !== rollDriver) {
    t5 = rollDriver && <div className="flex flex-col gap-3" data-validation-field="rollQuantity">{!customerSkus.includes(CustomerSku.ExemptOutsideDiameter) && <p className="text-sm leading-5 text-muted-foreground">We can accommodate custom roll sizes that produce rolls of up to a 9" diameter.</p>}<RollQuantity labelId={labelId} /><ValidationError field="rollQuantity" /></div>;
    $[7] = customerSkus;
    $[8] = labelId;
    $[9] = rollDriver;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex flex-col gap-3">{t3}{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(state) {
  return state.rollDriver;
}